import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { DialogContainer, dialogAnimations } from "../Dialog";
import { baseDialogMargins } from "../Dialog/Dialog";
import { AnimatePresence } from 'framer-motion';
import React from 'react';
import styled from 'styled-components';
import { theme } from "../../theme";
import { AccordionDialogController } from "./useAccordionDialog";
/**
 * AccordionDialog
 *
 * A prescribed way to stack multiple dialogs together in an
 * accordion like behavior.
 */

export function AccordionDialog(_ref) {
  var initialFocusRef = _ref.initialFocusRef,
      isShowing = _ref.isShowing,
      onRequestClose = _ref.onRequestClose,
      _ref$zIndex = _ref.zIndex,
      zIndex = _ref$zIndex === void 0 ? theme.zIndices.modal : _ref$zIndex,
      _ref$enableClickOutsi = _ref.enableClickOutsideToClose,
      enableClickOutsideToClose = _ref$enableClickOutsi === void 0 ? true : _ref$enableClickOutsi,
      children = _ref.children,
      expanded = _ref.expanded,
      defaultExpanded = _ref.defaultExpanded,
      onExpandedChange = _ref.onExpandedChange,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      other = _objectWithoutProperties(_ref, ["initialFocusRef", "isShowing", "onRequestClose", "zIndex", "enableClickOutsideToClose", "children", "expanded", "defaultExpanded", "onExpandedChange", "size"]);

  return /*#__PURE__*/React.createElement(DialogContainer, {
    initialFocusRef: initialFocusRef,
    isShowing: isShowing,
    onRequestClose: onRequestClose,
    zIndex: zIndex,
    enableClickOutsideToClose: enableClickOutsideToClose
  }, function (ref, state, id) {
    return /*#__PURE__*/React.createElement(AccordionDialogController, {
      size: size,
      expanded: expanded,
      onExpandedChange: onExpandedChange,
      defaultExpanded: defaultExpanded
    }, /*#__PURE__*/React.createElement(StyledAccordionDialog, _extends({
      role: "dialog",
      "aria-labelledby": id,
      ref: ref,
      "data-state": state
    }, other), /*#__PURE__*/React.createElement(AnimatePresence, {
      initial: false
    }, children)));
  });
}
var StyledAccordionDialog = styled.div.withConfig({
  displayName: "AccordionDialog__StyledAccordionDialog",
  componentId: "vapor__sc-17z1ntz-0"
})(["", ";", ";display:flex;flex-direction:column;align-items:center;"], dialogAnimations, baseDialogMargins);